<mat-card appearance="outlined" *ngIf="showAsCard">
  <mat-card-content>
    <ng-container [ngTemplateOutlet]="container"></ng-container>
  </mat-card-content>
</mat-card>

<div *ngIf="!showAsCard">
  <ng-container [ngTemplateOutlet]="container"></ng-container>
</div>

<ng-template #container>
  <div
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="center center"
    class="wrapper"
  >
    <mat-icon class="icon" *ngIf="icon"> {{ icon }}</mat-icon>
    <div class="text">{{ text }}</div>
  </div>
</ng-template>
